
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable 
      max-width="800px"
      transition="dialog-transition"
    >
      <base-card with_divider>
        <template slot="title">
          <span class="text-capitalize">
            {{ $tc('stages.edit')}}
          </span>
        </template>

        <template v-slot:content>
          <v-form ref="stageForm">
            <v-text-field 
              :placeholder="$t('stages.name_form_label')"
              solo flat class="black--text" style="font-weight: 900; font-size: large !important;"
              v-model="local_stage.name" dense
              :rules="required"
            ></v-text-field>

            <v-row class="px-3 mb-5">
              <b class="subtitle-1 black--text mr-2">Status: </b>
                <v-menu v-model="status_menu" offset-y :close-on-content-click="true" width="300px">
                  <template v-slot:activator="{on}">
                    <v-chip @click="status_menu = true" v-on="on" :color="`status_${local_stage.status}`">
                      <v-avatar left size="20" :color="`status_${local_stage.status}`" class="ml-0">
                        <v-icon x-small :color="`status_${local_stage.status}_dot`">mdi-circle</v-icon>
                      </v-avatar>
                      {{ $t(`statuses.${local_stage.status}`) }}
                    </v-chip>
                  </template>
                  
                  <v-list v-if="status_menu">
                    <v-list-item v-for="status in statuses_options" :key="status" @click="local_stage.status = status;">
                      <v-list-item-content>
                        {{$t(`statuses.${status}`)}}
                      </v-list-item-content>
                    </v-list-item>
                    <!-- <v-list-item @click="() => {}">
                      <v-list-item-content>
                        aaaaa
                      </v-list-item-content>
                    </v-list-item> -->
                    
                  </v-list>
                </v-menu>
            </v-row>

            <v-row align="center" class="pa-3">
              <b class="subtitle-1 black--text mb-6 mr-2"> {{$t('stages.quantity_alterations')}}: </b>
              <v-col cols="2" class="pa-0">
                <v-text-field filled rounded
                  class="rounder" dense
                  v-model="local_stage.qtd_alterations"
                  :rules="[ruleNumberEqualGreaterThan(0)]"
                  type="number" min="0"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row align="center" class="pa-3">
              <b class="subtitle-1 black--text mb-6 mr-2"> {{ $t('stages.expected_duration_form_label') }}: </b>
              <v-col cols="2" class="pa-0">
                <v-text-field filled rounded
                  class="rounder" dense
                  v-model="local_stage.default_duration_days"
                  :rules="[ruleNumberEqualGreaterThan(1)]"
                  type="number" min="1"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row align="center" class="pa-3">
              <b class="subtitle-1 black--text mb-6 mr-2"> {{ $t('stages.started_at_form_label') }}: </b>
              <v-col cols="4" class="pa-0">
                <vc-date-picker v-model="local_stage.started_at" :max-date='local_stage.expected_conclusion_at || null'>
                  <template v-slot="{ inputValue, togglePopover }">
                    <v-text-field rounded filled dense class="rounder" 
                      :value="local_stage.started_at && $dayjs(local_stage.started_at).format('DD/MM/YYYY') || ''"
                      :rules="required"
                      placeholder="--"
                      @focus="togglePopover()"
                      readonly
                      prepend-inner-icon="mdi-calendar"
                      clearable
                      @click:clear="local_stage.started_at = null"
                    ></v-text-field>
                  </template>
                </vc-date-picker>
              </v-col>
            </v-row>

            <v-row align="center" class="pa-3">
              <b class="subtitle-1 black--text mb-6 mr-2"> {{ $t('stages.expected_conclusion_at_form_label') }}: </b>
              <v-col cols="4" class="pa-0">
                <vc-date-picker v-model="local_stage.expected_conclusion_at" :min-date='local_stage.started_at || null'>
                  <template v-slot="{ inputValue, togglePopover }">
                    <v-text-field rounded filled dense class="rounder" 
                      :value="local_stage.expected_conclusion_at && $dayjs(local_stage.expected_conclusion_at).format('DD/MM/YYYY') || ''"
                      :rules="required"
                      @focus="togglePopover()"
                      placeholder="--"
                      readonly
                      prepend-inner-icon="mdi-calendar"
                      clearable
                      @click:clear="local_stage.expected_conclusion_at = null"
                    ></v-text-field>
                  </template>
                </vc-date-picker>
              </v-col>
            </v-row>

            <v-row align="center" class="pa-3" v-if="local_stage.status == 'done'">
              <b class="subtitle-1 black--text mb-6 mr-2"> {{ $t('stages.concluded_at_form_label') }}: </b>
              <v-col cols="4" class="pa-0">
                <vc-date-picker v-model="local_stage.concluded_at" :min-date='local_stage.started_at || null'>
                  <template v-slot="{ inputValue, togglePopover }">
                    <v-text-field rounded filled dense class="rounder" 
                      :value="local_stage.concluded_at && $dayjs(local_stage.concluded_at).format('DD/MM/YYYY') || ''"
                      :rules="required"
                      @focus="togglePopover()"
                      placeholder="--"
                      readonly
                      prepend-inner-icon="mdi-calendar"
                      clearable
                    ></v-text-field>
                  </template>
                </vc-date-picker>
              </v-col>
            </v-row>

          </v-form>
        </template>

        <template slot="actions">
          <v-btn small color="error" class="font-weight-bold" @click="cancel" text>{{ $t('cancel') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="primary" class="font-weight-bold" @click="save" text>{{ $t('save') }}</v-btn>
        </template>

      </base-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import Api from '@/api/index';

export default {
  name: 'DialogOneStage',
  mixins: [ validations ],
  components: {
    //ComponentName: () => import(''),
  },
  props: {
    stage: {
      type: Object,
      // default: 
    },
    position: {
      type: [String, Number],
    },
    max_positions: {
      type: [String, Number],
    },
  },
  data() {
    return {
      dialog: true,
      local_stage: {},

      status_menu: false,

      statuses_options: [
        "not_started", "doing", "overdue", "canceled", "done", "waiting" 
      ],
    }
  },
  methods: {
    setDates(from){
      setTimeout(() => {
        const {started_at, expected_conclusion_at, default_duration_days} = this.local_stage
        if (started_at && !expected_conclusion_at && default_duration_days) {
          let conc = this.$dayjs(started_at).add(default_duration_days, 'day').format()
          this.local_stage.expected_conclusion_at = conc
  
        } else if (!started_at && expected_conclusion_at && default_duration_days){
          let st = this.$dayjs(expected_conclusion_at).subtract(default_duration_days, 'day').format()
          this.local_stage.started_at = st
  
        } else if (started_at && expected_conclusion_at && from != 'dur'){
          let diff = this.$dayjs(expected_conclusion_at).diff(this.$dayjs(started_at), 'day', true)
          this.local_stage.default_duration_days = Math.ceil(diff)
        } else if (from == 'dur' && started_at){
          let conc = this.$dayjs(started_at).add(default_duration_days, 'day').format()
          this.local_stage.expected_conclusion_at = conc
        }
      }, 200);
    },
    cancel(){
      this.$emit('cancel')
    },
    save(){
      if (this.$refs.stageForm.validate()){
        this.$emit('done', {...this.local_stage})
      }
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    dialog(nv,ov) {
      if (nv == false){
        this.cancel()
      }
    },
    'local_stage.started_at'(nv,ov) {
      this.setDates('st')
    },
    'local_stage.expected_conclusion_at'(nv,ov) {
      this.setDates('conc')
    },
    'local_stage.default_duration_days'(nv,ov) {
      this.setDates('dur')
    },
  },
  mounted () {
    this.local_stage = {
      ...this.stage,
      ...this.stage.json_attributes,
    };
  },
}
</script>

<style scoped>

</style>